import React, { useMemo } from 'react'
import { FormBuilderV3, FormRows } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import { isClickId, isProgramReferral } from '../../logical/queryParams'

import FormContainer from 'components/FormContainer'

import {
  FormItem,
  FormRow,
  HeroHeader,
  StyledText,
  GreenText,
  StyledPasswordInput,
  StyledLabel,
  Link,
} from './styled-components'
import { FormikValues, FormikErrors } from 'formik'

const ResidencyLabel = ({ openAgreementModal }) => (
  <StyledLabel>
    Yes, I am a U.S. Resident, 18 years or older, and agree to the Acorns{' '}
    <Link onClick={openAgreementModal('program_agreement')}>Program Agreement</Link>,{' '}
    <Link onClick={openAgreementModal('acorns_privacy_policy')}>Privacy Policy</Link> and{' '}
    <Link onClick={openAgreementModal('eft_agreement')}>Auto Debit Authorization</Link>. I agree to
    use my electronic signature for all agreements and to receive documents electronically.
  </StyledLabel>
)

const PartnerDisclosureLabel = ({ openAgreementModal }) => (
  <StyledLabel>
    I have read the{' '}
    <Link onClick={openAgreementModal('partner_agreement')}>Partner Referral Disclosure</Link>
  </StyledLabel>
)

interface PasswordViewProps {
  values: FormikValues
  errors: FormikErrors<FormikValues>
  openAgreementModal: (agreement: string) => void
  setFieldValue: (field: string, value: any) => void
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const PasswordView = ({
  values,
  onChange,
  errors,
  openAgreementModal,
  setFieldValue,
}: PasswordViewProps) => {
  const { getRemoteString } = useRemoteStrings()

  const rows = useMemo(() => {
    const rows: FormRows = [
      [
        {
          label: <ResidencyLabel openAgreementModal={openAgreementModal} />,
          name: 'usResident',
          sizes: { sm: 12, md: 12, xs: 12 },
          className: `signup-checkbox ${(isClickId() || isProgramReferral()) && 'resident-checkbox'}`,
          type: 'checkbox',
        },
      ],
    ]

    if (isClickId() || isProgramReferral()) {
      rows.push([
        {
          label: <PartnerDisclosureLabel openAgreementModal={openAgreementModal} />,
          name: 'partnerDisclosure',
          sizes: { sm: 12, md: 12, xs: 12 },
          className: 'signup-checkbox',
          type: 'checkbox',
        },
      ])
    }

    return rows
  }, [openAgreementModal])

  return (
    <>
      <HeroHeader>
        <StyledText>
          {getRemoteString({
            key: 'create_account.password_input.body.variable',
            variables: [''],
          })}
          <GreenText>{values.email}</GreenText>
        </StyledText>
      </HeroHeader>
      <FormContainer>
        <FormRow>
          <FormItem>
            <StyledPasswordInput
              label="Password"
              value={values.password}
              className="text-input"
              name="password"
              inputVersion="v3"
              onChange={onChange}
              data-testid="password_input"
              required={true}
              placeholder="Password"
              errors={!!errors.password}
              toggleIcon
            />
          </FormItem>
        </FormRow>
        <FormBuilderV3
          errors={errors}
          rows={rows}
          values={values}
          handleChange={onChange}
          setFieldValue={setFieldValue}
        />
      </FormContainer>
    </>
  )
}
